// modules
import { Observable } from 'rxjs'
import { delay, filter, retryWhen } from 'rxjs/operators'
import * as pako from 'pako'
import { getHook, setHooks } from '../logic/hooks'
import '../logic/pingPong'
// actions
import { queueAck, queuePush } from '../logic/queue/queue.action'
import { getSocket, setSocket } from '../logic/socket'
import {
  resetTimers,
  handleWsGet,
  wsGetNow,
  wsGetCreator,
} from '../logic/wsGet'
// store
import { dispatch } from './redux'

const RETRY_INTERVAL = 1000
const ACK_PREFIX = 'ACK'.padEnd(64, '_')

window.WebSocket.prototype.isOpen = function isOpen() {
  return this.readyState === window.WebSocket.OPEN
}

const handleAck = data => {
  if (typeof data === 'string' && data.startsWith(ACK_PREFIX)) {
    const ack = Number(data.slice(ACK_PREFIX.length))
    dispatch(queueAck(ack))
    return true
  }
  return false
}

export default (socketCreator, hooks) => {
  setHooks(hooks)
  let sock
  let retry = true

  return {
    ws$: new Observable(subscriber => {
      const socket = socketCreator()
      setSocket(socket)

      socket.onopen = () => {
        socket.pingStart()
        getHook('onConnection')()
      }

      socket.onmessage = async ({ data }) => {
        if (socket.pingHandle(data)) return
        if (handleAck(data)) return

        try {
          const stringData =
            typeof data === 'string'
              ? data
              : pako.inflate(await data.arrayBuffer(), {
                  to: 'string',
                })
          subscriber.next(JSON.parse(stringData))
        } catch (error) {
          console.log(
            'ws-client error in parsing action: ',
            error,
            ', data:',
            data,
          )
        }
      }

      socket.myClose = reason => {
        if (socket.closed) {
          console.log('WebSocket is already closed.')
          return
        }
        console.log('WebSocket closed because of', reason)

        socket.closed = true
        socket.pingStop()
        resetTimers()
        subscriber.error()
        getHook('onDisconnection')(reason)
      }

      socket.onclose = socket.myClose

      socket.onerror = socket.myClose

      sock = socket
      return () => socket.close()
    }).pipe(
      filter(action => !handleWsGet(action)),
      retryWhen(error$ =>
        error$.pipe(
          filter(() => retry),
          delay(RETRY_INTERVAL),
        ),
      ),
    ),
    reConnect: () => sock.myClose('reconnection'),
    terminateConnection: () => {
      retry = false
      if (sock) sock.myClose('terminate connection requested')
    },
  }
}

/**
 * serializes and sends the payload with websocket if it's open
 * @param payload the payload to be sent
 * @returns {boolean} true if socket was open and payload was sent; false
 *     otherwise
 */
export const sendNow = payload => {
  const socket = getSocket()
  if (socket.isOpen()) {
    socket.send(JSON.stringify(payload))
    return true
  }
  return false
}

// TODO: why removing timeout doesn't work??!
export const send = (...args) =>
  setTimeout(() => dispatch(queuePush(...args)), 0)

const wsGet = wsGetCreator(send)

export { wsGetNow, wsGet }
